
<template>
  <div class="app-top">
    <div class="container">
      <b-tabs content-class="mt-3">
        <b-tab title="账户信息" active class="box">
          <p>手机号码：{{tenantInfo.account}}</p>
          <p>公司名称：{{tenantInfo.name}}</p>
          <p>到期时间：{{tenantInfo.validDate}}</p>
        </b-tab>
        <b-tab title="Second">
          <p>I'm the second tab</p>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import API from '@/api/user'
export default {
  components: {},
  name: 'Account',
  data() {
    return {
      tenantInfo: {}
    }
  },
  watch: {},
  computed: {},
  mounted() {},
  created() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      API.getInfo({}).then(res => {
        this.tenantInfo = {
          account: res.data.tenantAccount,
          name: res.data.tenantName,
          code: res.data.tenantCode,
          logoUrl: res.data.tenantLogoUrl,
          validDate: res.data.tenantValidDate,
          userCount: res.data.tenantUserCount,
          storeCount: res.data.tenantStoreCount
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.app-top {
  margin-top: 78px;
  min-height: calc(100vh - 370px);
}
.box {
  padding: 20px;
  background: #fff;
}
</style>